import React, { useState } from 'react';
import { editPick } from '../repository/draftsRepository';

interface EditPickModalProps {
    draftUuid: string;
    pickNumber: number;
    currentValue: string;
    onClose: () => void;
    onSave: () => void;
}

const EditPickModal: React.FC<EditPickModalProps> = ({
    draftUuid,
    pickNumber,
    currentValue,
    onClose,
    onSave
}) => {
    const [value, setValue] = useState(currentValue);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        if (!value.trim()) {
            setError('Pick value is required');
            return;
        }

        setLoading(true);

        const result = await editPick(draftUuid, pickNumber, value.trim());

        if ('error' in result) {
            setError(result.error);
            setLoading(false);
            return;
        }

        onSave();
    };

    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="modal-backdrop" onClick={handleBackdropClick}>
            <div className="modal">
                <div className="modal-header">
                    <h3>Edit Pick #{pickNumber}</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={handleSubmit} className="modal-form">
                    {error && <div className="error-message">{error}</div>}
                    <div className="form-group">
                        <label htmlFor="pickValue">Pick Value</label>
                        <input
                            type="text"
                            id="pickValue"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            disabled={loading}
                            autoFocus
                        />
                    </div>
                    <div className="modal-actions">
                        <button
                            type="button"
                            className="btn-secondary"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn-primary"
                            disabled={loading || !value.trim()}
                        >
                            {loading ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditPickModal;
